import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';


export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    item: JSON.parse(sessionStorage.getItem('user'))|| {},
    userId: sessionStorage.getItem('userId') || '',
    token: sessionStorage.getItem('token') || '',
    items: [],
    adminToken: sessionStorage.getItem('adminToken') || '',
    adminUser: JSON.parse(sessionStorage.getItem('adminUser')) || {},
    adminUserId: sessionStorage.getItem('adminUserId') || '',
  },
  actions,
  getters,
  mutations,
};


